<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold">Mottagare</p>
    </div>
    <div class="modal-content">
      <div class="grid2col">
        <div class="all-caps">namn</div>
        <div class="all-caps text-right">skicka meddelande</div>
      </div>

      <div v-for="(bidreceiver, index) in bidReceivers" :key="index" class="mt-15">
        <div class="grid2col">
          <div class="mb-5">{{ bidreceiver.firstname || bidreceiver.name }} {{ bidreceiver.lastname }}</div>
          <div class="text-center">
            <label class="switch">
              <input type="checkbox" v-model="bidreceiver.send">
              <div class="slider round"></div>
            </label>
          </div>
        </div>
      </div>


      <div class="grid2col grid2col--21 mt-30">
        <div><input type="text" v-model="customReceiver" placeholder="Andra mottagare..."></div>
        <div class="flex align-middle"><button class="p5" @click="addCustomReceiver">lägg till</button></div>
      </div>

      <button class="width-100 outline mb-15 mt-50" @click="send">SKICKA SMS/MEJLA</button>
    </div>

    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'receivers',
  data() {
    return {
      chosen: [],
      customReceiver: '',
    }
  },
  computed: {
    sendSmsMailToThese() {
      return _.filter(this.bidReceivers, {send: true});
    },
    stakeHolders() {
      return this.$store.state.currentListingWithBiddings.stakeholderGroups;
    },
    bidReceivers() {
      let bidReceivers = [];

      this.$store.getters.getAllStakeHolders.forEach((receiver) => {
        receiver.send = !this.customerIsExceptedFromBids(receiver);
        bidReceivers.push(receiver);
      })

      return bidReceivers;
    }
  },
  methods: {
    // returns true if the customer id exists in the exceptions array
    customerIsExceptedFromBids(customer) {
      if (this.$store.state.currentListingWithBiddingsBidReceivers.exceptions) {
        return !!_.find(this.$store.state.currentListingWithBiddingsBidReceivers.exceptions, {customerId: customer.id});
      } else {
        return false;
      }
    },
    saveCustomReceiver(data) {
      // simple sanity check before saving
      if (!data.email && !data.cellphone) {
        alert("Någonting gick fel. Felkod: 10295");
        return false;
      }
      data.objectId = this.$route.params.id;
      data.alias = data.cellphone ? data.cellphone : data.email;

      // save new bid receiver
      this.$root.callFasAdApi("/internalapi/bid/add-receiver-addition/", "POST", data)
      .then(() => {
        this.$store.dispatch('storeBidReceivers', { id: this.$route.params.id });
      })
      .catch(console.error);
    },
    addCustomReceiver() {
      let empty = {
        firstname: this.customReceiver,
        lastname: ''
      }

      // If its numbers only, we add the string as cellphone
      if (this.$root.isNumeric(this.customReceiver)) {
        empty.cellphone = this.customReceiver;
        this.chosen.push(empty);
        this.saveCustomReceiver(empty);
        this.customReceiver = "";
      }

      else if (this.customReceiver.includes('@')) {
        empty.email = this.customReceiver;
        this.chosen.push(empty);
        this.saveCustomReceiver(empty);
        this.customReceiver = "";
      }

      else {
        alert("Måste vara nummer eller epost adress");
        this.customReceiver = "";
      }
    },
    send() {
      this.$store.commit('STORE_SMS_MAIL_WHICH_SERVICE', 'bidding');
      this.$root.modalOpen = false;
      // set default sms and set receivers chosen from boxes
      this.$store.commit('STORE_SMS_MAIL_DELIVERYWAY', 'sms');
      this.$store.commit('STORE_SMS_MAIL_RECIEVERS', this.sendSmsMailToThese);
      // trigger the send message modal
      this.$emit('submitted', { component: "sendSmsOrMail" });
    },
    abort() {
      this.$store.dispatch('storeBidReceivers', { id: this.$route.params.id });
      this.$root.modalOpen = false;
    },
    save() {
      this.bidReceivers.forEach((receiver) => {
        let addOrRemoveExceptionData = {
          "customerId": receiver.id,
          "objectId": this.$route.params.id
        };

        // if send is false and not in exception we add exception
        if (!receiver.send && !this.customerIsExceptedFromBids(receiver)) {
          this.$root.callFasAdApi("/internalapi/bid/add-receiver-exception", "POST", addOrRemoveExceptionData)
          .then((data) => {
            console.log(data);
          })
          .catch(console.error);
        } else if (receiver.send && this.customerIsExceptedFromBids(receiver)) {
          // remove from exceptions
          this.$root.callFasAdApi("/internalapi/bid/delete-receiver-exception", "DELETE", addOrRemoveExceptionData)
          .then((data) => {
            console.log(data);
          })
          .catch(console.error);
        }
      });
      this.$root.modalOpen = false;
      this.$store.dispatch('storeBidReceivers', { id: this.$route.params.id });
    }
  }
}
</script>
